import {Pipe, PipeTransform} from '@angular/core';
import {SharedUtils} from '../utils/shared-utils';
import {Utils} from '@astek/utils';

@Pipe({
  name: 'xpSecondsToString',
})
export class SecondsToStringPipe implements PipeTransform {

  constructor() {
  }

  public transform(value: number | null | undefined, minutesOnTwoDigits?: boolean): string {
    if (Utils.isNullOrUndefined(value)) {
      return (minutesOnTwoDigits ? '-' : '') + '-:--';
    }
    if (Number.isNaN(value)) {
      console.error('NaN value !');
    }
    return SharedUtils.secondsToString(value, minutesOnTwoDigits);
  }

}
